import { render, staticRenderFns } from "./add-rlist-user.html?vue&type=template&id=9d953d4a&scoped=true&external"
import script from "./add-rlist-user.js?vue&type=script&lang=js&external"
export * from "./add-rlist-user.js?vue&type=script&lang=js&external"
import style0 from "./add-rlist-user.scss?vue&type=style&index=0&id=9d953d4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d953d4a",
  null
  
)

export default component.exports